<template>
    <div class="">
        <div class="room__collapse accordion" id="accordionExample">
            <div class="card">
                <div class="card-header p-0" id="headingOne">
                    <button class="room__collapse__header" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Advanced Search
                        <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="5.414" viewBox="0 0 9.414 5.414" class="arrow__collapsible">
                        <g id="Grupo_6049" data-name="Grupo 6049" transform="translate(8.707 4.707) rotate(180)">
                            <line id="Línea_794" data-name="Línea 794" x2="4" y2="4" transform="translate(4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                            <line id="Línea_795" data-name="Línea 795" x1="4" y2="4" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                        </g>
                        </svg>
                    </button>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <h1 class="view__title title--1" v-html="title_page"/>
                        <LocalFormSearch
                        :form_data="form_data"
                        :array_options="array_options"
                        :boolean_options="boolean_options"
                        :radio_options="radio_options"
                        :simbol_options="simbol_options"
                        :excl_options="excl_options"
                        @debounceInput="debounceInput"
                        @resetList="resetList"
                    />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-2 border show-hide" v-if="for_reports" style="max-height: auto">
                <h6 class="mb-3 reports__show-hide__title">Show/Hide</h6>
                <div class="row mb-3 no-gutters templates__grid border rounded">
                    <div class="templates__grid__tabs" style="max-width: 300px">
                        <div id="nav-tab" role="tablist" class="nav nav-tabs templates__grid__item d-flex justify-content-between">
                            <a class="templates__grid__tabs__item rounded active pl-0" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" v-html="'Fields'" style="width: 50%;" @click="view_by_fields = true"/>
                            <a class="templates__grid__tabs__item rounded pl-0" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false" v-html="'Totals'" style="width: 50%;" @click="view_by_fields = false"/>
                        </div>
                    </div>
                </div>
                <div style="max-height: 35em" class="overflow-auto show-hide__list" v-if="view_by_fields">
                    <span data-v-25f661d4="" class="custom-control custom-checkbox w-100 mb-3" v-for="(item, index) in table_headers" :key="index">
                        <input data-v-25f661d4="" :id="item.text" type="checkbox" class="custom-control-input" v-model="item.show">
                        <label data-v-25f661d4="" :for="item.text" class="custom-control-label reports__show-hide__label ml-2">{{ item.text }}</label>
                    </span>
                </div>
                <div style="max-height: 35em" class="overflow-auto show-hide__list" v-if="!view_by_fields">
                    <div v-for="(total_section, index) in totals" :key="index">
                        <span data-v-25f661d4="" class="custom-control custom-checkbox w-100 mb-3" v-for="(item, index) in total_section" :key="index">
                            <input data-v-25f661d4="" :id="item.text" type="checkbox" class="custom-control-input" v-model="item.show">
                            <label data-v-25f661d4="" :for="item.text" class="custom-control-label reports__show-hide__label ml-2">{{ item.text }}</label>
                        </span>
                    </div>
                </div>
            </div>
            <div :class="for_reports ?  'col-lg-10' : 'col-lg-12'">
                <v-card>
                    <DinamicTableInfiniteLoader
                        :name="'AdvancedSearch'"
                        :selectable_columns="selectable_columns"
                        :array_options_table="(use_parent) ? parent_array_options_table : array_options_table"
                        :totals="(use_parent) ? parent_totals : totals"
                        :headers="computed_table_headers"
                        :items="(use_parent) ? parent_rooms :rooms"
                        :pagination="(use_parent) ? parent_pagination :pagination"
                        :search="search"
                        :checkable="true"
                        :link="child_href"
                        :size="30"
                        :historiable="historiable"
                        :updateable="updateable"
                        :detail_text="detail_text"
                        :for_reports="for_reports"
                        @emitToUpdate="$emit('modal_update', $event)"
                        @fetchMainList="fetchMainList($event)"
                        @history="$emit('history', $event)"
                        @paginateMoreRecords="paginateMoreRecords($event)"
                        @orderRequest="orderRequest($event)"
                        ref="main_table"
                    />
                </v-card>
            </div>
        </div>

        <WaitingModal v-if="checkeable === undefined && !checkeable"/>
    </div>
</template>

<script>

import Resources        from    '@/components/BuildingComponent/Rooms/AdvancedSearch/resources'
import FormResources    from    '@/components/BuildingComponent/Rooms/AdvancedSearch/form_resources'
import WaitingModal     from    '@/components/WaitingModal'
import DinamicTableInfiniteLoader     from    '@/components/DinamicTableInfiniteLoader'
import LocalFormSearch  from    './LocalFormSearch'
import Methods          from    './methods'
import { Notyf }        from    'notyf'
import _ from 'lodash'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'RoomAdvancedSearch',

    props:[
        'parent_rooms',
        'parent_pagination',
        'parent_array_options_table',
        'parent_totals',
        'use_parent',
        'detail_text',
        'checkeable',
        'rest_api',
        'rest_api_pagination',
        'historiable',
        'updateable',
        'table_headers',
        'search',
        'show_sq_ft',
        'for_reports',
        'selectable_columns'
    ],

    components:{
        WaitingModal,
        LocalFormSearch,
        DinamicTableInfiniteLoader,
    },

    mixins:[
        Methods,
    ],

    data(){
        return{
            notyf,
            title_page:                 'Advanced search',
            child_href:                 '/building-room/',
            rest_api_search:            'rooms_advanced_search',
            local_table_headers:        Resources.table_headers,
            breadcrumb:                 Resources.breadcrumb,
            form_data:                  FormResources.form_data,
            radio_options:              Resources.radio_options,
            boolean_options:            Resources.boolean_options,
            status_options:             Resources.status_options,
            excl_options:               Resources.excl_options,
            simbol_options:             Resources.simbol_options,
            shift_criteria_options:     Resources.shift_criteria_options,
            rooms:                      [],
            array_options:              {},
            selectAll:                  false,
            tasks: [],
            pagination: null,
            array_options_table: [],
            first_time_flags: {},
            totals: {},
            view_by_fields: true,

        }
    },

    methods:{

        debounceInput:  _.debounce(function (e)  {
            this.form_data[e.field] = e.value
        }, 0),


        checkingOrigins(rooms_origin_id)
        {
            rooms_origin_id.forEach(origin_id => 
            {
                let indexFound = this.rooms.findIndex(room => room.origin_id === origin_id)
                
                if(indexFound > -1)
                {
                    this.rooms[indexFound].checked = true
                    window.$(`#advancedItems${indexFound}`).prop('checked', true)
                }
            })
        },
        replacingRooms(rooms, search_key = 'origin_id')
        {
            rooms.forEach(updated_room => {

                let found_index = this.rooms.findIndex(room => room[search_key] === updated_room[search_key])
                if(found_index > -1)
                {
                    updated_room.checked = true;
                    this.rooms.splice(found_index, 1, updated_room)
                }
            })
        },

        async paginateMoreRecords(params)
        {
            if(this.use_parent)
            {
                this.$emit('paginateMoreRecordsParent', params)

                return;
            }

            if(this.rooms.length >= this.pagination?.total)
            {
                return;
            }
            
            await this.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            if(this.use_parent)
            {
                this.$emit('fetchMainListParent', params)

                return;
            }
            this.rooms = [];
            await this.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            
            this.pagination = data.pagination

            if(reset_list)
            {
                this.rooms = []
            }

            if(this.pagination.data.length)
            {
                this.pagination.data.forEach((item) => {
                    item.checked = this.$refs.main_table.select_all
                    this.rooms.push(item)
                })
            }

            if(this.show_sq_ft)
            {
                this.array_options_table = [
                    {
                        text: 'Total Sq. Footage',
                        type: 'number',
                        value: data.sq_ft
                    }
                ]
            }

            if(data.totals)
            {
                this.totals = data.totals
            }

            if(data.rooms)
            {
                await this.hideLoader(data.rooms)
            }
            else
            {
                await this.hideLoader(data.rooms || data.pagination.data)
            }
        },

        isSelectAll()
        {
            return this.$refs.main_table.select_all
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        },

        orderRequest(event)
        {
            this.$emit('orderRequest', event)
        },
        resetSelectAll()
        {
            this.$refs.main_table.resetSelectAll()
        }



    },

    async mounted()
    {
        if(this.hasPermissions(['Building-Room Read']))
        {
            await this.api_request()

            this.firstRequestWithParams()
            
        }
        else
        {
            window.location.href = '/'
        }
    },

    computed: 
    {
        computed_table_headers()
        {
            let table_headers = (this.table_headers && this.table_headers.length) ? this.table_headers : this.local_table_headers
            
            return table_headers.filter(item => item.show === undefined || item.show)
        }
    }


}

</script>